import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE, timeout: 20000 });

// A static host with an SPA fallback answers an unknown /api path with index.html
// and a 200, so a missing backend arrives here looking like success. Anything that
// is not a decoded JSON body is a failed call: reject it so the caller's .catch
// runs and the page shows its unavailable state instead of destructuring HTML.
api.interceptors.response.use((r) => {
  if (r.data === null || typeof r.data !== "object") {
    return Promise.reject(new Error(`Expected JSON from ${r.config?.url}, got ${typeof r.data}`));
  }
  return r;
});

export const marketing = {
  catalog: () => api.get("/marketing/catalog").then((r) => r.data),
  calc: (body) => api.post("/marketing/calc", body).then((r) => r.data),
  demoWhitespace: () => api.get("/marketing/demo-whitespace").then((r) => r.data),
  lead: (body) => api.post("/marketing/leads", body).then((r) => r.data),
};

// Real commerce endpoint (backend/orders.py). Gated server-side by
// COMMERCE_PUBLIC (off by default) and, if set, an invite code — this call
// is safe to ship even before self-serve purchase is switched on; it will
// 403 with a clear message until then.
export const commerce = {
  createOrder: (body) => api.post("/public/orders", body).then((r) => r.data),
};

export const fmtMoney = (n, currency = "USD", max = 0) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency, maximumFractionDigits: max, minimumFractionDigits: 0 }).format(n || 0);

export const fmtDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric", timeZone: "UTC" });
};
